
import { AppStateContext } from "./appState";
import { LogoutProvider } from "./LogoutContext";
import { GlobalProgressDialog, ProgressContextProvider } from "./ProgressContextProvider";

import { JSX } from "react";

export type T_ContextsProps = {
  children: JSX.Element;
};

function Contexts({ children }: T_ContextsProps) {
  return (
    <AppStateContext>
      <LogoutProvider>
      <ProgressContextProvider>
      <GlobalProgressDialog />
        {children}
      </ProgressContextProvider>
      </LogoutProvider>
    </AppStateContext>
  );
}

export default Contexts;
